import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Place the Sign',
    desc: 'Place the elegant TapShare sign on a table at your event.'
  }, {
    num: '2',
    title: 'Guests Tap',
    desc: 'Guests simply tap the sign with their smartphone.'
  }, {
    num: '3',
    title: 'Instant Gallery',
    desc: 'Photos appear instantly in your live, private gallery.'
  }];
  return <section className="py-24 px-6 bg-dark-lighter relative" data-id="element-84">
      <div className="max-w-5xl mx-auto" data-id="element-85">
        <FadeIn className="text-center mb-20" data-id="element-86">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-cream mb-6" data-id="element-87">
            How It Works
          </h2>
          <p className="text-gold text-xl font-medium" data-id="element-88">
            Real-time photo sharing during the event
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-12 relative" data-id="element-89">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[2px] bg-gradient-to-r from-gold/0 via-gold/30 to-gold/0 z-0" data-id="element-90"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} className="relative z-10 flex flex-col items-center text-center" data-id="element-91">
              <div className="w-24 h-24 rounded-full bg-dark border-2 border-gold flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(201,168,76,0.15)]" data-id="element-92">
                <span className="font-heading text-4xl text-gold" data-id="element-93">
                  {step.num}
                </span>
              </div>
              <h3 className="text-2xl font-heading text-cream mb-3" data-id="element-94">
                {step.title}
              </h3>
              <p className="text-cream-dark/70 text-lg leading-relaxed" data-id="element-95">
                {step.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}